'use strict';

import croppieModal from '../../modules/croppieModal';

const challenge = {
  settings: {
    $form: document.querySelector('.js-form-warcry'),
  },

  init() {
    croppieModal.init();
  },
};

const _this = challenge,
  s = _this.settings;

export default _this;
